import React,{ useState,useEffect } from 'react';
import MenuProductView from './MenuProductView';
import AnimationBtn from './AnimationBtn';
import MenuFeatures from './MenuFeatures';
import Howtousenew from './Howtousenew';
import HowToUse from './HowToUse';
import FooterControl from './FooterControl';
import FooterControlMob from './FooterControlMob';
import Hidden from '@material-ui/core/Hidden';
import Button from '@material-ui/core/Button';
import $ from 'jquery';

import '../../farbtastic/farbtastic';
import '../../farbtastic/farbtastic.css';


var isipad = (/CriOS/i.test(navigator.userAgent) && /ipad/i.test(navigator.userAgent)) || (navigator.userAgent.indexOf('iPad') != -1) || (navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2) || (navigator.userAgent == "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_6) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/15.6,2 Safari/605.1.15");

var mob = (navigator.userAgent.indexOf("iPhone") != -1) || ((navigator.userAgent.indexOf("Android") != -1)) || (navigator.userAgent.indexOf('iPod') != -1) || (navigator.userAgent == "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.0.1 Safari/605.1.15") || (navigator.userAgent == "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_6) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/15.6,2 Safari/605.1.15");

var mobPortrait = (mob && window.innerHeight > window.innerWidth);
var moblandscap = (mob && window.innerWidth > window.innerHeight);
export const userContext = React.createContext();


var buttonSeq = ['onResetMode','onFrontClick','onTopClick','onRightClick','onLeftClick','onBackClick','onHDRGBCameraClick','onHDCameraClick','backliteClick','onZoneClick','onPerKeyClick','openCloseClick'];

var buttonSeqNew = ['onResetMode','onFrontClick','onTopClick','onRightClick','onLeftClick','onBackClick','onHDRGBCameraClick','onHDCameraClick','backliteClick','onZoneClick','onPerKeyClick','openCloseClick'];

var selectedButton = 'onResetMode';
var picker = null;

const MainMenu = (props) => {
   const [expandedPanel,setExpandedPanel] = useState(false);
   const [laptop360FrontImg,setLaptop360FrontImg] = useState("./img/pos_front.png");
   const [laptop360BackImg,setLaptop360BackImg] = useState("./img/pos_back.png");
   const [laptop360TopImg,setLaptop360TopImg] = useState("./img/pos_top.png");
   const [laptop360LeftImg,setLaptop360LefttImg] = useState("./img/pos_left.png");
   const [laptop360RightImg,setLaptop360RightImg] = useState("./img/pos_right.png");

   const [backlit,setBacklite] = useState("./img/Backlite_Off.png");
   const [opneClose,setOpenClose] = useState("./img/Lid_open.svg");
   const [openCloseOnOff,setOpenCloseOnOff] = useState(false);
   const [backliteOnOff,setBackliteOnOff] = useState(false);

   var [onOffBacklit,setOnOffBacklit] = useState(false);
   var animCounter = 0;
   var [screenAnimInterval,setScreenAnimInterval] = useState(0);
   var backlitPlay = './img/RAINBOW_PLAY.svg';
   var backlitPause = './img/RAINBOW_PAUSE.svg';
   const [kbType,setKbType] = useState('Cherry/RGB per key');
   const [camType,setcamType] = useState('HD RGB-IR camera');
   const [portType,setportType] = useState('E Port');
   var mainRoot = window.document.getElementById("root");

   const [animValue,setAnimValue] = useState("on");
   const [animValue1,setAnimValue1] = useState("On");
   var targetDiv;


   function onRAINBOW_PAUSE() {
      // console.log("onRAINBOW_PAUSE");
      // window.scene.groupApplyState('RGB_OFF');
      setOnOffBacklit(false);

      if (document.getElementById('onOffkeyBoBacklitAnim')) {
         document.getElementById('onOffkeyBoBacklitAnim').src = backlitPlay;
      }
      // window.scene.materialSet("Keys_To_mat_copy","diffusecolor",[1,0,0]);
      // window.scene.materialSet("Touchpad_mat_copy","diffusecolor",[1,0,0]);
      // window.scene.materialSet("Alien_HEAD_RGB_mat_copy","diffusecolor",[1,0,0]);
      // window.scene.materialSet("Keys_To_mat_copy","diffusecolor",[1,0,0]);
      // window.scene.clearRefine();
      clearInterval(screenAnimInterval);
      animCounter = 1;
      window.scene.clearRefine();
   }

   function onColorChange() {
      if (targetDiv) return;
      // console.log("-----")
      onRAINBOW_PAUSE();
      // console.log("-----",hexToRgb(picker.color).r);
      var r = (parseInt(hexToRgb(picker.color).r)) / 255;
      var g = (parseInt(hexToRgb(picker.color).g)) / 255;
      var b = (parseInt(hexToRgb(picker.color).b)) / 255;
      // window.scene.materialSet("KeyBoard_TO","diffusecolor",[r,g,b]);
      window.scene.materialSet("RearLightRING","diffusecolor",[r,g,b]);
      window.scene.materialSet("Alien_HEAD_Purple","diffusecolor",[r,g,b]);
      window.scene.materialSet("KeyBoard_TO","diffusecolor",[r,g,b]);
      // window.scene.groupApplyState('RGB_Default');
      window.scene.groupApplyState('RGB_OFF');

      window.scene.clearRefine();
   }

   document.addEventListener('mouseover',function (event) {
      targetDiv = mainRoot.contains(event.target);

      if (!targetDiv) {
         // picker.setColor("#02ffff"); //set initial color
         picker.linkTo(onColorChange); //link to callback
      }
   })
   function hexToRgb(hex) {
      // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
      var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex,function (m,r,g,b) {
         return r + r + g + g + b + b;
      });

      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
         r: parseInt(result[1],16),
         g: parseInt(result[2],16),
         b: parseInt(result[3],16)
      } : null;
   }

   function TestChangeTexture2(SCREENCh) {
      if (window.scene) {

         var mat1 = window.scene._Material_ref["Alien_HEAD_RGB_mat_copy"];
         var mat2 = window.scene._Material_ref["Keys_To_mat_copy"];
         // var mat3 = window.scene._Material_ref["Alien_Light_mat_copy"];
         // var mat4 = window.scene._Material_ref["Alien_HEAD_RGB_mat_copy"];


         mat1.setTexture(SCREENCh,window.TEXTURE_MAP_DIFFUSETEX);
         mat2.setTexture(SCREENCh,window.TEXTURE_MAP_DIFFUSETEX);
         // mat3.setTexture(SCREENCh,window.TEXTURE_MAP_DIFFUSETEX);
         // mat4.setTexture(SCREENCh,window.TEXTURE_MAP_DIFFUSETEX);
         window.scene.clearRefine();
      }
   }

   $(function () {
      picker = $.farbtastic('#picker'); //picker variable
   });

   const handleAccordionChange = (panel) => (event,isExpanded) => {

      if (isExpanded) {
         setExpandedPanel(panel);
         //console.log("shubham");
      } else {
         //  console.log("Pawar");
         setExpandedPanel(false)
      };
      // resetBacklitCloseImg();

   };
   var animationSwitch = window.Animation;
   window.animTime = 1;


   useEffect(() => {
      if (animValue === 'on') {
         window.Animation = 'on'
      }
      animationSwitch = window.Animation;
      moblandscap = (mob && window.innerWidth > window.innerHeight);

      if (document.querySelector('#blackBtn')) {
         document.querySelector('#blackBtn').classList.add('Mui-disabled');
      }
      if (document.getElementById('whiteBtn')) {
         document.getElementById('whiteBtn').classList.add('select');
      }



      return () => {
         clearInterval(screenAnimInterval);
         animCounter = 0;
      }
   },[]);



   if (animationSwitch == 'on') { window.animTime = 1000 }
   else { window.animTime = 1 }

   const resetAll = () => {
      if (animationSwitch == 'on') { window.animTime = 1000 }
      else { window.animTime = 1 }
      targetDiv = false;
      setOpenCloseOnOff(false);
      setOpenClose("./img/Lid_open.svg");
      setBackliteOnOff(false);
      setBacklite("./img/Backlite_Off.png");

      if (document.getElementById('orion-keyboard-color-menu-wrapper')) {
         document.getElementById('orion-keyboard-color-menu-wrapper').style.display = 'none'
      }
      if (document.getElementById('onOffkeyBoBacklitAnim')) {
         document.getElementById('onOffkeyBoBacklitAnim').src = backlitPlay;
      }
      window.scene.groupApplyState('GP_ON');
      picker.setColor("#18f2f2");
      onColorChange();
      setOnOffBacklit(false);
      clearInterval(screenAnimInterval);
      animCounter = 0;
      window.scene.groupApplyState('RGB_Default');
      window.scene.clearRefine();
   }

   window.onOffkeyBoBacklit = () => {
      if (onOffBacklit) {
         // console.log("off RAINBOW_PLAY");
         setOnOffBacklit(false);

         if (document.getElementById('onOffkeyBoBacklitAnim')) {
            document.getElementById('onOffkeyBoBacklitAnim').src = backlitPlay;
         }
         window.scene.groupApplyState('GP_ON');
         window.scene.groupApplyState('RGB_OFF');
         clearInterval(screenAnimInterval);
         animCounter = 0;
      } else {
         // console.log("on RAINBOW_PLAY");
         setOnOffBacklit(true);
         // window.scene.groupApplyState('backLit_OFF');
         if (document.getElementById('onOffkeyBoBacklitAnim')) {
            document.getElementById('onOffkeyBoBacklitAnim').src = backlitPause;
         }
         window.scene.groupApplyState('GP_OFF');
         window.scene.groupApplyState('RGB_ON');
         setScreenAnimInterval(setInterval(function () {
            TestChangeTexture2(window.screen[animCounter]);
            animCounter++;
            if (animCounter == 74) {
               animCounter = 0;
            }
         },200))
      }
      window.scene.clearRefine();
   }


   //MenuProductView
   const onFrontClick = (isNextPrevious) => {

      var slider = document.getElementById("sliderRange");
      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }

      resetAll();
      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      if (document.getElementById('frontBtn')) {

         document.getElementById('frontBtn').classList.add('active');

      }
      selectedButton = 'onFrontClick';
      if (!(mob || isipad)) {
         if (document.getElementById('previousView')) {
            document.getElementById('previousView').setAttribute('aria-label','Front view');
         }
         if (document.getElementById('nextView')) {
            document.getElementById('nextView').setAttribute('aria-label','Front view');
         }
      }
      window.scene.applySequence(window.Front_View);

   }

   const onBackClick = (isNextPrevious) => {

      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }

      resetAll();

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      if (document.getElementById('backBtn')) {
         document.getElementById('backBtn').classList.add('active');
      }

      selectedButton = 'onBackClick';
      if (!(mob || isipad)) {
         if (document.getElementById('previousView')) {
            document.getElementById('previousView').setAttribute('aria-label','Back view');
         }
         if (document.getElementById('nextView')) {
            document.getElementById('nextView').setAttribute('aria-label','Back view');
         }
      }
      // window.scene.groupApplyState('keys_RGB_off_');
      window.scene.applySequence(window.Rear_View);
   }

   const onTopClick = (isNextPrevious) => {

      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }

      //reset All Functions
      resetAll();

      selectedButton = 'onTopClick';
      if (!(mob || isipad)) {
         if (document.getElementById('previousView')) {
            document.getElementById('previousView').setAttribute('aria-label','Top view');
         }
         if (document.getElementById('nextView')) {
            document.getElementById('nextView').setAttribute('aria-label','Top view');
         }
      }

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }

      document.getElementById('topBtn').classList.add('active');

      // window.scene.groupApplyState('keys_RGB_off_');
      window.scene.applySequence(window.Top_View);

   }

   const onRightClick = (isNextPrevious) => {

      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }

      resetAll();

      selectedButton = 'onRightClick';
      if (!(mob || isipad)) {
         if (document.getElementById('previousView')) {
            document.getElementById('previousView').setAttribute('aria-label','right view');
         }
         if (document.getElementById('nextView')) {
            document.getElementById('nextView').setAttribute('aria-label','right view');
         }
      }
      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }

      document.getElementById('rightBtn').classList.add('active');

      // window.scene.groupApplyState('keys_RGB_off_');
      window.scene.applySequence(window.Right_View);

   }

   const onLeftClick = (isNextPrevious) => {

      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }

      //reset All Functions
      resetAll();

      selectedButton = 'onLeftClick';

      if (!(mob || isipad)) {
         if (document.getElementById('previousView')) {
            document.getElementById('previousView').setAttribute('aria-label','left view');
         }
         if (document.getElementById('nextView')) {
            document.getElementById('nextView').setAttribute('aria-label','left view');
         }
      }

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }

      document.getElementById('leftBtn').classList.add('active');
      // window.scene.groupApplyState('keys_RGB_off_');
      window.scene.applySequence(window.Left_View);

   }

   //MenuFeatureView
   const openCloseClick = () => {

      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }

      //reset All Functions
      resetAll();

      selectedButton = 'openCloseClick';

      window.closeMode = 'on';
      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }

      document.getElementById('openCloseBtn').classList.add('active');

      if (openCloseOnOff) {
         document.getElementById('openCloseBtn').setAttribute('aria-label','');
         document.getElementById('openCloseLid').innerHTML = 'Open Lid';

         if (!(mob || isipad)) {
            if (document.getElementById('previousView')) {
               document.getElementById('previousView').setAttribute('aria-label','Open Lid');
            }
            if (document.getElementById('nextView')) {
               document.getElementById('nextView').setAttribute('aria-label','Open Lid');
            }
         }
         setOpenCloseOnOff(false);
         setOpenClose("./img/Lid_open1.svg");
         window.scene.applySequence(window.FL_View);

      } else {

         document.getElementById('openCloseBtn').setAttribute('aria-label','');
         document.getElementById('openCloseLid').innerHTML = 'Close Lid';
         if (!(mob || isipad)) {
            if (document.getElementById('previousView')) {
               document.getElementById('previousView').setAttribute('aria-label','Close Lid');
            }
            if (document.getElementById('nextView')) {
               document.getElementById('nextView').setAttribute('aria-label','Close Lid');
            }
         }
         setOpenCloseOnOff(true);
         setOpenClose("./img/Lid_close.svg");
         window.scene.applySequence(window.Close_View);

      }
      // if (!(isipad || mob)) {
      //    for (let i = 1; i <= allDocumentIds.length; i++) {
      //       if (document.getElementById(allDocumentIds[i])) {
      //          document.getElementById(allDocumentIds[i]).setAttribute("tabindex", "0");
      //       }
      //    }
      // }
   }

   const backliteClick = () => {
      var slider = document.getElementById("sliderRange");
      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }
      resetAll();
      selectedButton = 'backliteClick';
      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) alreadySelected.classList.remove('active');
      document.getElementById('backlitBtn').classList.add('active');

      // window.scene.groupApplyState('keys_RGB_off_');

      // console.log(kbType);
      if (kbType == '1-zone keyboard') {
         document.getElementById('onOffkeyBoBacklit').style.display = 'none';
      } else {
         document.getElementById('onOffkeyBoBacklit').style.display = 'block';

      }
      if (backliteOnOff) {
         // alert("backliteOnOff");
         setBackliteOnOff(false);

         setBacklite("./img/Backlite_Off.png");
         if (document.getElementById('backlitBtn')) {
            document.getElementById('backlitBtn').setAttribute('aria-label','');
         }
         document.getElementById('backlitOnnOff').innerHTML = 'Backlit off';
         if (!(mob || isipad)) {
            if (document.getElementById('previousView')) {
               document.getElementById('previousView').setAttribute('aria-label','Backlit off');
            }
            if (document.getElementById('nextView')) {
               document.getElementById('nextView').setAttribute('aria-label','Backlit off');
            }
         }
         if (document.getElementById('orion-keyboard-color-menu-wrapper')) {
            document.getElementById('orion-keyboard-color-menu-wrapper').style.display = 'none'
         }

         // window.scene.groupApplyState("BackLit_OFF");
         // window.scene.groupApplyState('Red_OFF');



      } else {
         // alert("else");
         // console.log("**************on");
         setBackliteOnOff(true);

         setBacklite("./img/Backlite_On.png");
         // window.scene.groupApplyState('BackLit_ON');

         document.getElementById('backlitBtn').setAttribute('aria-label','');
         document.getElementById('backlitOnnOff').innerHTML = 'Backlit on';
         if (!(mob || isipad)) {
            if (document.getElementById('previousView')) {
               document.getElementById('previousView').setAttribute('aria-label','Backlit on');
            }
            if (document.getElementById('nextView')) {
               document.getElementById('nextView').setAttribute('aria-label','Backlit on');
            }
         }
         if (document.getElementById('orion-keyboard-color-menu-wrapper')) {
            document.getElementById('orion-keyboard-color-menu-wrapper').style.display = 'block'
         }

         // window.scene.groupApplyState('RGB_Default');
         window.scene.groupApplyState('RGB_OFF');

         picker.setColor("#18f2f2");


         setBackliteOnOff(true);
         setBacklite("./img/Backlite_On.png");

         picker.linkTo(onColorChange);
      }
      window.scene.applySequence(window.Top_View);
      // if (!(isipad || mob)) {

      //    for (let i = 1; i <= allDocumentIds.length; i++) {
      //       if (document.getElementById(allDocumentIds[i])) {
      //          document.getElementById(allDocumentIds[i]).setAttribute("tabindex", "0");
      //       }
      //    }
      // }


   }


   const resetMode = () => {
      selectedButton = 'onResetMode';
      window.scene.applySequence(window.FL_View);
      if (!(mob || isipad)) {
         document.getElementById('previousView').setAttribute('aria-label','Reset Mode');

         document.getElementById('nextView').setAttribute('aria-label','Reset Mode');
      }
   }
   const onResetMode = () => {

      var slider = document.getElementById("sliderRange");
      // console.log("----",selectedButton)
      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }
      if (selectedButton == 'onFrontClick') {
         onFrontClick();

      } else if (selectedButton == 'onBackClick') {
         //  console.log("Back onreset")
         onBackClick();
      }
      else if (selectedButton == 'onTopClick') {
         //   console.log("top onreset")
         onTopClick();

      }
      else if (selectedButton == 'onRightClick') {
         //  console.log("Right onreset")
         onRightClick();

      }
      else if (selectedButton == 'onLeftClick') {
         //  console.log("Left onreset")
         onLeftClick();

      }
      else if (selectedButton == 'backliteClick') {
         //  console.log("Left onreset")
         if (backliteOnOff) {
            backliteClick();
            setBackliteOnOff(false);
         } else {
            backliteClick();
            setBackliteOnOff(true);
         }

      }

      else if (selectedButton == 'onZoneClick') {
         // console.log("onZoneClick onreset")
         onZoneClick();

      }
      else if (selectedButton == 'onPerKeyClick') {
         onPerKeyClick();

      }

      else if (selectedButton == 'onHDCameraClick') {
         onHDCameraClick();
      }
      else if (selectedButton == 'onHDRGBCameraClick') {
         onHDRGBCameraClick();
      }
      // else if (selectedButton == 'onEPortCameraClick') {
      //    onEPortCameraClick();
      // }

      // else if (selectedButton == 'onPPortCameraClick') {
      //    onPPortCameraClick();
      // }


      else if (selectedButton == 'openCloseClick') {
         if (openCloseOnOff) {

            window.scene.applySequence(window.Close_View);


         } else {


            window.scene.applySequence(window.Close_View);

         }

      }
      else if (selectedButton == 'onResetMode') {
         resetMode();

      }

   }


   const onPreviousMode = () => {

      //Update ZoomBar
      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }
      // alert(selectedButton)

      var prevButton;

      /* if (window.finalLangues.lang.toLowerCase() === "ja" || window.finalLangues.lang.toLowerCase() === "ko" ||
         window.finalLangues.lang.toLowerCase() === "zh-tw" || window.finalLangues.lang.toLowerCase() === "zh-cn" || window.finalLangues.lang.toLowerCase() === "en" || window.finalLangues.lang.toLowerCase() === "en-us") {
         var selectedButtonIndex = buttonSeq.findIndex(element => element === selectedButton)
         if (selectedButton == 'onFrontClick' || selectedButton == 'onResetMode') {
            prevButton = 'openCloseClick';
            openCloseClick(true);
            setExpandedPanel("panel3");

         }
         else {
            prevButton = buttonSeq[selectedButtonIndex - 1];
         }
      }

      else { */
      var selectedButtonIndex = buttonSeqNew.findIndex(element => element === selectedButton)
      if (selectedButton == 'onFrontClick' || selectedButton == 'onResetMode') {
         prevButton = 'openCloseClick';
         openCloseClick(true);
         setExpandedPanel("panel3");
      }
      else {
         prevButton = buttonSeqNew[selectedButtonIndex - 1];
      }
      //}


      if (prevButton == 'onFrontClick') onFrontClick(true);
      else if (prevButton == 'onBackClick') {
         onBackClick(true);
         setExpandedPanel("panel1");

      }
      else if (prevButton == 'onTopClick') onTopClick(true);
      else if (prevButton == 'onRightClick') onRightClick(true);
      else if (prevButton == 'onPerKeyClick') onPerKeyClick(true);

      else if (prevButton == 'onZoneClick') {
         onZoneClick(true);
      }
      else if (prevButton == 'onLeftClick') {
         onLeftClick(true);

      }
      else if (prevButton == 'openCloseClick') {

         openCloseClick(true);
         setExpandedPanel("panel3");
      }
      else if (prevButton == 'onHDRGBCameraClick') {

         onHDRGBCameraClick(true);
         setExpandedPanel("panel3");
      }
      else if (prevButton == 'onHDCameraClick') {
         onHDCameraClick(true);
         setExpandedPanel("panel3");
      }
      // else if (prevButton == 'onEPortCameraClick') {
      //    onEPortCameraClick(true);
      // }
      // else if (prevButton == 'onPPortCameraClick') {
      //    onPPortCameraClick(true);
      // }

      else if (prevButton == 'backliteClick') {
         // setExpandedPanel("panel3");
         backliteClick(true);
      }

   }

   const onNextMode = () => {

      //Update ZoomBar
      var slider = document.getElementById("sliderRange");
      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }


      var nextButton;

      /* if (window.finalLangues.lang.toLowerCase() === "ja" || window.finalLangues.lang.toLowerCase() === "ko" ||
         window.finalLangues.lang.toLowerCase() === "zh-tw" || window.finalLangues.lang.toLowerCase() === "zh-cn" || window.finalLangues.lang.toLowerCase() === "en" || window.finalLangues.lang.toLowerCase() === "en-us") {
         var selectedButtonIndex = buttonSeq.findIndex(element => element === selectedButton)
         if (selectedButton == 'openCloseClick') {
            nextButton = 'onFrontClick';
            setExpandedPanel("panel1");
            // backliteClick(true);
            onFrontClick(true);
            // setExpandedPanel("panel3");
         }
         else {
            nextButton = buttonSeq[selectedButtonIndex + 1];
            //console.log(nextButton,selectedButtonIndex);
         }
         // onPerKeyClick(true);
         // resetAll();
      }

      else { */
      var selectedButtonIndex = buttonSeqNew.findIndex(element => element === selectedButton)
      if (selectedButton == 'openCloseClick') {
         nextButton = 'onFrontClick';
         setExpandedPanel("panel1");
         // backliteClick(true);
         onFrontClick(true);
         // setExpandedPanel("panel3");
      }
      else {
         nextButton = buttonSeqNew[selectedButtonIndex + 1];
         //console.log(nextButton,selectedButtonIndex);
      }
      //}




      if (nextButton == 'onFrontClick') {
         onFrontClick(true);
         setExpandedPanel("panel1");
      }
      else if (nextButton == 'onBackClick') {
         onBackClick(true);

      }
      else if (nextButton == 'onTopClick') onTopClick(true);
      else if (nextButton == 'onRightClick') onRightClick(true);
      else if (nextButton == 'onZoneClick') {
         onZoneClick(true);
      }
      else if (nextButton == 'onPerKeyClick') onPerKeyClick(true);
      else if (nextButton == 'onLeftClick') {
         onLeftClick(true);
      }

      else if (nextButton == 'openCloseClick' || nextButton == 'onResetMode') {
         nextButton = 'openCloseClick';
         openCloseClick(true);
         // setExpandedPanel("panel1");

      }
      else if (nextButton == 'backliteClick') {
         // console.log("backliteClick next");
         backliteClick(true);
         setExpandedPanel("panel3");

      }
      else if (nextButton == 'onHDRGBCameraClick') {
         onHDRGBCameraClick(true);
         setExpandedPanel("panel3");

      }
      else if (nextButton == 'onHDCameraClick') {
         onHDCameraClick(true);
         setExpandedPanel("panel3");

      }
      // else if (nextButton == 'onEPortCameraClick') {
      //    onEPortCameraClick(true);

      // }
      // else if (nextButton == 'onPPortCameraClick') {
      //    onPPortCameraClick(true);

      // }


   }

   useEffect(() => {
      // alert();
      document.getElementById("animSwitchValue").setAttribute('aria-label','Animation On')
      document.getElementById("animSwitchValue").checked = true;
      setAnimValue("On");
      window.Animation = 'on';
      document.getElementsByClassName('onOff')[0].style.left = "-17px";
      window.animationSwitchVal = 'on';

      if (!(window.mob)) {
         document.getElementById("animSwitchValue1").setAttribute('aria-label','Animation On')
         // document.getElementById('animSwitchValue1').setAttribute('aria-label','clickable checkbox checked On');
         document.getElementById("animSwitchValue1").checked = true;
         document.getElementsByClassName('onOff1')[0].style.left = "-17px";
         setAnimValue1("On");

      }

   },[]);

   const setAnimationSwitch = (e) => {
      // console.log(e)
      // displayName(e);
      const isChecked = document.getElementById("animSwitchValue").checked;

      if (isChecked == true) {
         document.getElementById("animSwitchValue").setAttribute('aria-label','Animation Off');
         document.getElementById("animSwitchValue").checked = false;
         setAnimValue("Off");
         document.getElementsByClassName('onOff')[0].style.left = "9px";
         window.Animation = 'off';
         window.animationSwitchVal = 'off';

         window.RT_RecordEvent("Animations","Off",window.config.name);

      } else {
         document.getElementById("animSwitchValue").setAttribute('aria-label','Animation On')
         document.getElementById("animSwitchValue").checked = true;
         window.animationSwitchVal = 'on';
         setAnimValue("On");
         window.Animation = 'on';
         document.getElementsByClassName('onOff')[0].style.left = "-17px";

         window.RT_RecordEvent("Animations","On",window.config.name);
      }
   }

   const displayName = (e) => {
      // console.log(e)
      const isChecked = document.getElementById("animSwitchValue").checked;

      if (isChecked == true) {
         // console.log('is checked true')
         setAnimValue("On");
         window.Animation = 'on';
         document.getElementsByClassName('onOff')[0].style.left = "-17px";
         document.getElementById('animSwitchValue').setAttribute('aria-label','');
         document.getElementById('animSwitchValue').innerHTML = 'clickable checkbox checked On';
         window.animationSwitchVal = 'off';

      } else {
         // console.log('is checked false')
         setAnimValue("Off");
         document.getElementsByClassName('onOff')[0].style.left = "9px";
         window.Animation = 'off';
         document.getElementById('animSwitchValue').setAttribute('aria-label','');
         document.getElementById('animSwitchValue').innerHTML = 'clickable checkbox checked Off';
         window.animationSwitchVal = 'on';

      }

   }

   const setAnimationSwitch1 = (e) => {
      // console.log(e)
      // displayName(e);
      const isChecked = document.getElementById("animSwitchValue1").checked;

      if (isChecked == true) {
         //document.getElementById("animSwitchValue").setAttribute('aria-label', 'Animation Off');
         document.getElementById("animSwitchValue1").checked = false;
         setAnimValue1("Off");
         // keyboardOff();
         document.getElementsByClassName('onOff1')[0].style.left = "9px";
         window.animationSwitchVal = 'off';
         window.animationSwitchGlobal = 'off';

      } else {

         document.getElementById("animSwitchValue1").checked = true;

         setAnimValue1("On");
         window.animationSwitchVal = 'on';
         window.animationSwitchGlobal = 'on';
         document.getElementsByClassName('onOff1')[0].style.left = "-17px";

      }
   }
   var animStopped = true;

   const displayName1 = (e) => {
      if (animStopped == false) {
         return;
         animStopped = false;
      }
      // console.log(e)
      const isChecked = document.getElementById("animSwitchValue1").checked;

      if (isChecked == true) {
         setAnimValue1("On");
         // keyboardOn();
         window.animation1SwitchGlobal = 'on';
         document.getElementsByClassName('onOff1')[0].style.left = "-17px";
         document.getElementById('animSwitchValue1').setAttribute('aria-label','clickable checkbox checked On');
         window.animationSwitchVal = 'on';

         if (mob) {
            document.getElementById('footerControls').removeAttribute('style');
            document.getElementById('footerControMob').style.display = 'block';
         }
         else if (isipad) {
            // console.log('portrait');
            document.getElementById('footerControMob').style.display = 'block';
            document.getElementById('footerControls').style.display = 'block';
         }
         else {
            // console.log("show");

            document.getElementById('footerControls').style.transition = "bottom 0.2s linear";
            document.getElementById('footerControls').style.bottom = "20px";
            document.getElementById('footerControMob').style.transition = "bottom 0.2s linear";
            document.getElementById('footerControMob').style.bottom = "20px";

            document.getElementById('footerControls').style.visibility = "";
            document.getElementById('footerControIpad').style.visibility = "";
            document.getElementById('footerControMob').style.visibility = "";

         }


      } else {
         setAnimValue1("Off");
         // keyboardOff();
         document.getElementsByClassName('onOff1')[0].style.left = "9px";
         window.animation1SwitchGlobal = 'off';

         document.getElementById('animSwitchValue1').setAttribute('aria-label','clickable checkbox checked Off');

         if (mob) {
            document.getElementById('footerControls').removeAttribute('style');
            document.getElementById('footerControMob').style.display = 'none';
         } else if (isipad) {
            // console.log('landscape');
            document.getElementById('footerControMob').style.display = 'none';
            document.getElementById('footerControls').style.display = 'none';
         }
         else {
            // console.log("hide");
            document.getElementById('footerControls').style.bottom = "-112px";
            document.getElementById('footerControMob').style.bottom = "-112px";

            setTimeout(function () {

               document.getElementById('footerControls').style.visibility = "hidden";
               document.getElementById('footerControIpad').style.visibility = "hidden";
               document.getElementById('footerControMob').style.visibility = "hidden";
               animStopped = true;
            },150);
         }

      }

   }
   const onPerKeyClick = (isNextPrevious) => {
console.log("check perkry only")
      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }
      resetAll();
      setKbType('Cherry/RGB per key');
      selectedButton = 'onPerKeyClick';
      if (!(mob || isipad)) {
         if (document.getElementById('previousView')) {
            document.getElementById('previousView').setAttribute('aria-label','Top view');
         }
         if (document.getElementById('nextView')) {
            document.getElementById('nextView').setAttribute('aria-label','Top view');
         }
      }


      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }

      // window.scene.groupApplyState('1_zone_Key_off');
      window.scene.applySequence(window.Per_Key);
      if (backliteOnOff) {

         if (document.getElementById('orion-keyboard-color-menu-wrapper')) {
            document.getElementById('orion-keyboard-color-menu-wrapper').style.display = 'none';
         }
         // document.getElementById('onOffkeyBoBacklit').style.display = 'none';
      }
      // window.scene.applySequence(window.Top_View);


   }
   const onZoneClick = (isNextPrevious) => {

      var slider = document.getElementById("sliderRange");

      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }
      resetAll();
      setKbType('1-zone keyboard');

      selectedButton = 'onZoneClick';
      if (!(mob || isipad)) {
         if (document.getElementById('previousView')) {
            document.getElementById('previousView').setAttribute('aria-label','Top view');
         }
         if (document.getElementById('nextView')) {
            document.getElementById('nextView').setAttribute('aria-label','Top view');
         }
      }
      window.scene.applySequence(window.One_Key);
      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      // window.scene.applySequence(window.Top_View);


   }

   const onHDRGBCameraClick = (isNextPrevious) => {

      // console.log("HDRGBCamera success!!!")
      var slider = document.getElementById("sliderRange");
      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }
      resetAll();
      setcamType('HD RGB-IR camera');
      window.scene.applySequence(window.FHD_IR);

      selectedButton = 'onHDRGBCameraClick';
      if (!(mob || isipad)) {
         if (document.getElementById('previousView')) {
            document.getElementById('previousView').setAttribute('aria-label','Top view');
         }
         if (document.getElementById('nextView')) {
            document.getElementById('nextView').setAttribute('aria-label','Top view');
         }
      }

      document.getElementById('laptopRadioHDRGB').classList.add('active');
      document.getElementById('twoinoneRadioHD').classList.remove('active');
      document.getElementById('twoinoneRadioHD').classList.remove('select');

      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }

      // window.scene.applySequence(window.Front_View);

   }

   const onHDCameraClick = (isNextPrevious) => {

      // console.log("HDCamera success!!!")
      var slider = document.getElementById("sliderRange");
      if (slider != null) {
         document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
         setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); },1000);
      }

      resetAll();
      setcamType('HD Camera');
      window.scene.applySequence(window.FHD);

      selectedButton = 'onHDCameraClick';
      if (!(mob || isipad)) {
         if (document.getElementById('previousView')) {
            document.getElementById('previousView').setAttribute('aria-label','Top view');
         }
         if (document.getElementById('nextView')) {
            document.getElementById('nextView').setAttribute('aria-label','Top view');
         }
      }
      var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
      if (alreadySelected != null) {
         alreadySelected.classList.remove('active');
      }
      // window.scene.applySequence(window.Front_View);
   }

   // const onEPortCameraClick = (isNextPrevious) => {

   //    console.log("HDCamera success!!!")
   //    var slider = document.getElementById("sliderRange");
   //    if (slider != null) {
   //       document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
   //       setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); }, 1000);
   //    }

   //    resetAll();
   //    setportType('E Port');
   //    // window.scene.applySequence(window.Rear_View);
   //    window.scene.applySequence(window.E_View);
   //    selectedButton = 'onEPortCameraClick';
   //    if (!(mob || isipad)) {
   //       if (document.getElementById('previousView')) {
   //          document.getElementById('previousView').setAttribute('aria-label', 'Top view');
   //       }
   //       if (document.getElementById('nextView')) {
   //          document.getElementById('nextView').setAttribute('aria-label', 'Top view');
   //       }
   //    }
   //    var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
   //    if (alreadySelected != null) {
   //       alreadySelected.classList.remove('active');
   //    }


   // }

   // const onPPortCameraClick = (isNextPrevious) => {

   //    console.log("HDCamera success!!!")
   //    var slider = document.getElementById("sliderRange");
   //    if (slider != null) {
   //       document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor();
   //       setTimeout(function () { document.getElementById("sliderRange").value = window.scene._nav.getZoomFactor(); }, 1000);
   //    }

   //    resetAll();
   //    setportType('P Port');
   //    // window.scene.applySequence(window.Rear_View);
   //    window.scene.applySequence(window.P_View);
   //    selectedButton = 'onPPortCameraClick';
   //    if (!(mob || isipad)) {
   //       if (document.getElementById('previousView')) {
   //          document.getElementById('previousView').setAttribute('aria-label', 'Top view');
   //       }
   //       if (document.getElementById('nextView')) {
   //          document.getElementById('nextView').setAttribute('aria-label', 'Top view');
   //       }
   //    }
   //    var alreadySelected = document.querySelector('.MuiAccordionDetails-root.active');
   //    if (alreadySelected != null) {
   //       alreadySelected.classList.remove('active');
   //    }




   // }


   return (

      <>
         {!mob && <HowToUse />}
         <Hidden only={['sm','md','lg','xl']}>

            <Button style={{ position: 'fixed',backgroundColor: '#F0F0F0',width: '100%',height: '56px',paddingTop: '15px',paddingBottom: '15px',zIndex: '1',border: '1px solid #E1E1E1',borderLeft: "none",borderRight: "none",borderRadius: "0",margin: "-1px 0px 0px 0px" }}
               variant="outlined"
               color="primary"
               endIcon={<img src="./img/cross.svg" alt="cross" style={{ marginLeft: '207px',height: '23px' }} />}
               onClick={props.toggleDrawerAction}
            >
               {window.finalLangues.mainMenu}
            </Button>
            <Howtousenew />

         </Hidden >
         <Hidden only={['md','lg','xl','xs']}>
            {moblandscap && <Howtousenew />}
         </Hidden>

         <Hidden only={["xs"]}>
            <FooterControl name="reset and next previous" onReset={onResetMode} onPrevious={onPreviousMode} onNext={onNextMode} />
         </Hidden>
         <Hidden only={['lg','xl']}>
            <FooterControlMob onResetMob={onResetMode} onPreviousMob={onPreviousMode} onNextMob={onNextMode} onResetIpad={onResetMode} onNextIpad={onNextMode} onPreviousIpad={onPreviousMode} />
         </Hidden>
         <div id="leftMenuBar">
            <MenuProductView tabIndex="-1" onFrontBtnClick={onFrontClick} onTopBtnClick={onTopClick} onLeftBtnClick={onLeftClick} onRightBtnClick={onRightClick} onBackBtnClick={onBackClick} imgfront={laptop360FrontImg} imgback={laptop360BackImg} imgtop={laptop360TopImg} imgleft={laptop360LeftImg} imgright={laptop360RightImg} name={`${window.finalLangues.productView}`} expanded={expandedPanel === 'panel1'} onChanged={handleAccordionChange('panel1')} />
            <MenuFeatures name={`${window.finalLangues.features}`} tabIndex="-1" onclicked={onPerKeyClick} onclickedtwo={onZoneClick} onclickedHD={onHDCameraClick} onclickedHDRGB={onHDRGBCameraClick} tobechange={opneClose} tobeChanged={backlit} openClosedClicked={openCloseClick} onOffBackliteClicked={backliteClick} expanded={expandedPanel === 'panel3'} onChanged={handleAccordionChange('panel3')} value={kbType} value1={camType} value2={portType} />
            <AnimationBtn onchange={displayName} forKeypress={setAnimationSwitch} value={animValue} onchange1={displayName1} forKeypress1={setAnimationSwitch1} value1={animValue1} />
         </div>

      </>
   );
}

export default MainMenu;